import React, { useState, useEffect } from "react";
import styles from "./ProductAdd.module.css";
import axios from "axios";
import Spin from "../Spinner/Spinner";
import Popup from "../Popup/Popup";
import Toggle from "../../utils/Toggle/Toggle";
import { API } from "../../config";
import { useNavigate, Link, useParams } from "react-router-dom";
import { BsSave2 } from "react-icons/bs";
import { toast } from "react-toastify";
import { useImageUpload } from "../ClientLogos/hooks/useImageUpload";

function ProductAdd() {
  const { cartId } = useParams();
  const [categories, setCategories] = useState([]);
  const [spin, setSpin] = useState(true);
  const [category, setCategory] = useState();
  const [sort, setSort] = useState(100);
  const [name, setName] = useState("");
  const [type, setType] = useState();
  const [desc, setDesc] = useState("");
  const [subDesc, setSubDesc] = useState("");
  const [itemDetails, setItemDetails] = useState();
  const [cost, setCost] = useState(0);
  const [margin, setMargin] = useState(0);
  const [brand, setBrand] = useState();
  const [available, setAvailable] = useState(false);
  const [customisation, setCustomisation] = useState(false);
  const [show, setShow] = useState(false);
  const [spinn, setSpinn] = useState(false);
  let navigate = useNavigate();

  const getData = async () => {
    const data = await fetch(`${API}/Admin/category/get`);
    const json = await data.json();
    setCategories(json.allcategory);
    setSpin(false);
  };

  const {
    selectedFile,
    imagePreview,
    uploadError,
    setUploadError,
    handleFileChange,
    uploadImage,
    resetImageState,
  } = useImageUpload();

  useEffect(() => {
    getData();
  }, []);

  const change = () => {
    setShow(false);
  };

  const addProductToCart = async (productId) => {
    if (!cartId) return;
    try {
      await new Promise((resolve) => setTimeout(resolve, 1500));
      const response = await axios.post(
        `${API}/Admin/carts/${cartId}/products`,
        {
          products: [
            {
              productId,
              quantity: 1,
            },
          ],
        }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Product added to cart successfully");
      } else {
        toast.error("Failed to add product to cart");
      }
    } catch (error) {
      console.error("Failed to add product to cart:", error);
      toast.error("Failed to add product to cart");
    }
  };

  const saveData = async (imageUrl) => {
    const data = {
      categoryId: category,
      sortId: sort,
      name: name,
      description: desc,
      sub_description: subDesc,
      item_Details: itemDetails,
      productType: type,
      cost: cost,
      margin: margin,
      image: [imageUrl],
      brandName: brand,
      available: available,
      cust_flag: customisation,
      createdBy: "60e9c7db11ab1428accf8278",
      updatedBy: "60e9c7db11ab1428accf8278",
      deletedBy: "60e9c7db11ab1428accf8278",
    };
    console.log(data);
    try {
      const res = await axios.post(`${API}/Admin/addProduct/`, data);
      console.log("Done");
      setShow(true);
      setSpinn(false);
      console.log(res);
      await addProductToCart(res.data._id);

      // Reset form state
      setName("");
      setBrand("");
      setCategory("");
      setSort("");
      setType("");
      setAvailable(false);
      setCustomisation(false);
      setDesc("");
      setSubDesc("");
      setItemDetails("");
      setCost(0);
      setMargin(0);
      resetImageState();

      navigate(-1);
    } catch (err) {
      console.log(err.message);
      setSpinn(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setUploadError("");

    if (!selectedFile) {
      setUploadError("Please select an image file");
      return;
    }

    window.scrollTo(0, 0);
    setSpinn(true);

    try {
      const uploadedImageUrl = await uploadImage(selectedFile);

      if (!uploadedImageUrl) {
        setUploadError("Failed to upload image. Please try again.");
        setSpinn(false);
        return;
      }

      await saveData(uploadedImageUrl);
    } catch (error) {
      console.error("Error in save process:", error);
      setUploadError("An error occurred. Please try again.");
      setSpinn(false);
    }
  };

  return (
    <>
      {spinn ? <Spin /> : null}
      {show ? (
        <Popup show={show} switch={change} message="Added Successfully" />
      ) : null}
      {spin ? (
        <Spin />
      ) : (
        <div className={styles.productcontainer}>
          <div className={styles.heading}>
            <div className={styles.upper}>
              <Link to="/">
                <span className={styles.swag}>
                  Website
                  <span className={styles.greater}> &gt; </span>
                </span>
              </Link>
              <Link to="/products">
                <span className={styles.swag}>
                  Products
                  <span className={styles.greater}> &gt; </span>
                </span>
              </Link>
              <span className={styles.req}>Add Product</span>
            </div>
            <form onSubmit={handleSubmit}>
              <div className={styles.productdesc}>
                <div className={styles.leftproductdesc}>
                  <h1 className={styles.details}>{name}</h1>
                  <h1 className={styles.iddetails}>ID : To be Generated</h1>
                  {/* <div className={styles.display}>
                                    <img src={image} className={styles.imagedisplay}></img>
                                </div> */}
                </div>
                <div className={styles.rightproductdesc}>
                  <div className={styles.button}>
                    <div className={styles.icon}>
                      <BsSave2 />
                    </div>
                    <input type="submit" className={styles.bttn} value="Save" />
                  </div>
                </div>
              </div>
              <div className={styles.items}>
                <h1 className={styles.head}>Product Information</h1>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Product Name : </div>
                  <input
                    name="productname"
                    placeholder="Product Name"
                    type="text"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    id={styles.gap}
                    required
                  ></input>
                </div>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Brand Name : </div>
                  <input
                    name="fullname"
                    placeholder="Brand Name"
                    type="text"
                    onChange={(event) => setBrand(event.target.value)}
                    id={styles.gap}
                    value={brand}
                    required
                  ></input>
                </div>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Category : </div>
                  <select
                    name="category"
                    id="dropdown"
                    className={styles.select}
                    onChange={(event) => setCategory(event.target.value)}
                    value={category}
                    required
                  >
                    <option value="" disabled selected hidden>
                      {" "}
                      Choose a Category
                    </option>
                    {categories.map((c, i) => {
                      return <option value={c._id}>{c.name}</option>;
                    })}
                  </select>
                </div>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Type : </div>
                  <select
                    name="producttype"
                    id="dropdown"
                    className={styles.select}
                    onChange={(event) => setType(event.target.value)}
                    value={type}
                    required
                  >
                    <option value="" disabled selected hidden>
                      {" "}
                      Choose the Type
                    </option>
                    <option value="C">Colored</option>
                    <option value="IP">Individual Products</option>
                    <option value="DC">Dual Colored</option>
                    <option value="NV">Named Variants</option>
                    <option value="UP">Unquantifiable Products</option>
                  </select>
                </div>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Sort Id : </div>
                  <input
                    name="sortid"
                    placeholder="Sort ID"
                    type="number"
                    value={sort}
                    onChange={(event) => setSort(event.target.value)}
                    id={styles.gap}
                    required
                  ></input>
                </div>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Availability : </div>
                  <input
                    name="availability"
                    placeholder="Availability"
                    type="text"
                    value={available ? "Available" : "Not Available"}
                    onChange={(event) => setSort(event.target.value)}
                    id={styles.gap}
                    disabled
                  ></input>
                  <div className={styles.togglebutton}>
                    <Toggle status={available} setStatus={setAvailable} />
                  </div>
                </div>
                <div className={styles.first}>
                  <div className={styles.itemhead}>Customisation : </div>
                  <input
                    name="customisation"
                    placeholder="Customisation"
                    type="text"
                    value={customisation ? "Available" : "Not Available"}
                    onChange={(event) => setSort(event.target.value)}
                    id={styles.gap}
                    disabled
                  ></input>
                  <div className={styles.togglebutton}>
                    <Toggle
                      status={customisation}
                      setStatus={setCustomisation}
                    />
                  </div>
                </div>
                <h1 className={styles.head}>Product Details</h1>
                <div className={styles.second}>
                  <div className={styles.deschead}>Description</div>
                  <textarea
                    name="desc"
                    placeholder="Description"
                    type="text"
                    onChange={(event) => setDesc(event.target.value)}
                    id={styles.desc}
                    value={desc}
                    // required
                  ></textarea>
                </div>
                <div className={styles.second}>
                  <div className={styles.deschead}>Sub-Description</div>
                  <textarea
                    name="subdesc"
                    placeholder="Add Product Sub-Description"
                    type="text"
                    onChange={(event) => setSubDesc(event.target.value)}
                    id={styles.desc}
                    value={subDesc}
                    // required
                  ></textarea>
                </div>
                <div className={styles.second}>
                  <div className={styles.deschead}>Item Details</div>
                  <textarea
                    name="fullname"
                    placeholder="Add Product Details"
                    type="text"
                    onChange={(event) => setItemDetails(event.target.value)}
                    id={styles.desc}
                    value={itemDetails}
                    // required
                  ></textarea>
                </div>
                <div className={styles.second} style={{ marginBottom: "60px" }}>
                  <div className={styles.deschead}>
                    Product Image <span style={{ color: "red" }}>*</span>
                  </div>
                  <input
                    name="product_image"
                    type="file"
                    accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                    onChange={handleFileChange}
                    id={styles.file}
                    required
                  ></input>
                  <p
                    style={{
                      fontSize: "14px",
                      fontStyle: "italic",
                    }}
                  >
                    Supported file types: JPEG, PNG, WebP
                  </p>
                  {uploadError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "8px",
                        marginBottom: "8px",
                      }}
                    >
                      {uploadError}
                    </div>
                  )}
                  {imagePreview && (
                    <div style={{ marginTop: "12px" }}>
                      <img
                        src={imagePreview}
                        alt="Preview"
                        style={{
                          maxWidth: "200px",
                          maxHeight: "200px",
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                        }}
                      />
                    </div>
                  )}
                </div>
                <h1 className={styles.pricehead}>Pricing</h1>
                <div className={styles.pricesubhead}>Product</div>
                <div className={styles.pricedetails}>
                  <div className={styles.cost}>
                    <div className={styles.rupeeicon}>&#8377;</div>
                    <input
                      name="cost"
                      placeholder="Cost"
                      type="number"
                      onChange={(event) => setCost(+event.target.value)}
                      id={styles.gaphalfirst}
                      step=".01"
                      value={cost}
                      required
                    ></input>
                  </div>
                </div>
                <div className={styles.pricesubhead}>Margin</div>
                <div className={styles.second}>
                  <input
                    name="margin"
                    placeholder="Margin"
                    type="number"
                    onChange={(event) => setMargin(+event.target.value)}
                    id={styles.pricegap}
                    value={margin}
                    step=".01"
                    required
                  ></input>
                  <div className={styles.percenticon}>%</div>
                </div>
                <div className={styles.pricesubhead}>Final Cost</div>
                <div className={styles.second}>
                  <div className={styles.cost}>
                    <div className={styles.rupeeicon}>&#8377;</div>
                    <input
                      name="total"
                      placeholder="Final Cost"
                      type="number"
                      id={styles.pricegap}
                      value={Math.round(cost * (1 + margin / 100))}
                      disabled
                    ></input>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default ProductAdd;
